module.exports = __webpack_public_path__ + "img/vn_vn.e75b0cf5.png";